export default class BlockIntroPricing {
    constructor(container, options) {
        const defaultOptions = {
            venueSelector: '.select-venue .venues .venue',
            selectedVenue: '',
            pleaseSelect: '.please-select-container',
            detailsContainer: '.details-container',
            venues: '.details-container-bottom .venue-container',
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.venueSelectors = this.container.querySelectorAll(this.options.venueSelector);
        this.pleaseSelect = this.container.querySelector(this.options.pleaseSelect);
        this.detailsContainer = this.container.querySelector(this.options.detailsContainer);
        this.venues = this.container.querySelectorAll(this.options.venues);
        
        if(this.options.selectedVenue !== '') {
            this.venueSelect(this.options.selectedVenue);
        }
        
        this.setEvents();
    }

    setEvents() {
        var self = this;
        this.venueSelectors.forEach(venue => {
            venue.addEventListener('click', function() {
                self.onVenueSelect(this);
            });
        });
    }

    onVenueSelect(elem) {
        var id = elem.dataset.id;
        this.venueSelect(id);
    }
    
    venueSelect(id) {
        this.pleaseSelect.classList.remove('active');
        this.filterVenues(id);
        this.detailsContainer.style.display = 'flex';
    }
    
    filterVenues(id) {
        this.venues.forEach(item => {
            if(item.dataset.venue == id) {
                item.classList.remove('inactive');
            }
            else if(!item.classList.contains('inactive')) {
                item.classList.add('inactive');
            }
        })
    }
}